import { getLanguage, languages } from "./i18n/dictionary";

export const getScoreLabels = (language?: keyof typeof languages | string) => [
  getLanguage(language).never,
  getLanguage(language).incidentally,
  getLanguage(language).sometimes,
  getLanguage(language).mostly,
  getLanguage(language).always,
];
